export class InvalidTokenError extends Error {
  constructor(name: string, token?: string) {
    super(`Invalid token for ${name}: ${token}`);
    this.name = this.constructor.name;
  }
}

export class UnauthorizedError extends Error {
  constructor(name: string = UnauthorizedError.name) {
    super(`Unauthorized`);
    this.name = name;
  }
}

// A failed save whose message is written for the admin: wrapSavingOperation shows it instead of the generic one.
export class SavingError extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}
